import React from 'react';
import './cerrar.css';

class Abierto extends React.Component {

    render() {
        return <React.Fragment>
            <svg id="cancel" xmlns="http://www.w3.org/2000/svg" width="16.755" height="16.755" viewBox="0 0 16.755 16.755">
                <g id="Grupo_420" data-name="Grupo 420" transform="translate(0 0)">
                    <path id="Trazado_213" data-name="Trazado 213" d="M9.3,8.378l7.26-7.26a.655.655,0,0,0-.926-.926l-7.26,7.26L1.117.192a.655.655,0,0,0-.926.926l7.26,7.26-7.26,7.26a.655.655,0,0,0,.926.926L8.377,9.3l7.26,7.26a.655.655,0,1,0,.926-.926Z" transform="translate(0 -0.001)" fill="#fafaf9" />
                </g>
            </svg>

        </React.Fragment>;
            }
}

export default Abierto;